import { Divider } from "antd";
import SpepInstructionCard from "./step-instruction-card";

export default function SubmittalBulkInstruction() {
  return (
    <div className="linking-group--right--content p-1 pr-12">
      <SpepInstructionCard
        title="Step 1:"
        detail="Select a Submittal from the dropdown."
        data-testid="submittal-bulk-instruction-step-1"
      />
      <SpepInstructionCard
        title="Step 2:"
        detail="To associate a Material, click Edit to open a list here. You can associate an Activity to the Material here."
        data-testid="submittal-bulk-instruction-step-2"
      />
      <SpepInstructionCard
        title="Step 3:"
        detail="Click Save to confirm changes."
        data-testid="submittal-bulk-instruction-step-3"
      />
      <Divider />
      <SpepInstructionCard
        title="Note"
        detail="Activities can be associated directly to Submittals, by switching the Setting on."
        data-testid="submittal-bulk-instruction-note-1"
      />
      <SpepInstructionCard
        title=""
        detail="Material tracking is enabled by default and can be switched off at any time."
        data-testid="submittal-bulk-instruction-note-2"
      />
      <Divider />
      <div className="px-2">
        <b className="mr-1">Changing the Selection</b>
        <div
          className="py-3"
          data-testid="submittal-bulk-instruction-changing-selection"
        >
          To add or remove items from the Submittals selected, go back to the
          Submittal Log page and reselect the Submittals you wish to Bulk Link.
        </div>
      </div>
    </div>
  );
}
